import styled from "styled-components";

const Body = styled.div`
  overflow: hidden;
  max-height: 200px;
  position: relative;
  margin-bottom: 10px;
`;

export default Body;
